import React from 'react';

export default function Main({ children }) {
	return <main>{children}</main>;
}
